var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2C15.75 1.80109 15.671 1.61032 15.5303 1.46967C15.3897 1.32902 15.1989 1.25 15 1.25C14.8011 1.25 14.6103 1.32902 14.4697 1.46967C14.329 1.61032 14.25 1.80109 14.25 2V22C14.25 22.1989 14.329 22.3897 14.4697 22.5303C14.6103 22.671 14.8011 22.75 15 22.75C15.1989 22.75 15.3897 22.671 15.5303 22.5303C15.671 22.3897 15.75 22.1989 15.75 22V19.994C18.386 19.967 19.854 19.803 20.828 18.828C22 17.657 22 15.771 22 12C22 8.229 22 6.343 20.828 5.172C19.854 4.197 18.386 4.033 15.75 4.006V2Z",
    fill: "#6C7275"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.172 18.828C4.343 20 6.229 20 10 20H13V4H10C6.229 4 4.343 4 3.172 5.172C2.001 6.344 2 8.229 2 12C2 15.771 2 17.657 3.172 18.828ZM13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12ZM9 12C9 12.2652 8.89464 12.5196 8.70711 12.7071C8.51957 12.8946 8.26522 13 8 13C7.73478 13 7.48043 12.8946 7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929C7.48043 11.1054 7.73478 11 8 11C8.26522 11 8.51957 11.1054 8.70711 11.2929C8.89464 11.4804 9 11.7348 9 12Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.403b5a891aa9b5068a6d5a7154097748.svg";
export { ForwardRef as ReactComponent };